var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Xyj-button',{ref:"downloadTemplate",staticStyle:{"padding":"7px"},attrs:{"type":"primary","label":_vm.$t('action.downloadTemplate'),"text":"下载模板"},on:{"click":_vm.onDefaultDownload}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-433b7665","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/upload/download.vue
// module id = null
// module chunks = 